import classNames from 'classnames';
import React from 'react';

type Props = {
  isActive: boolean;
  onClick: () => void;
  children: any;
};

const SizeAndCapacityButton = ({ isActive, children, onClick }: Props) => {
  return (
    <button
      onClick={onClick}
      className={classNames(
        'tw:inline-block tw:cursor-pointer tw:whitespace-nowrap tw:rounded-button tw:border tw:border-solid tw:border-brand-black tw:py-2 tw:px-5 tw:text-sm tw:font-semibold tw:transition tw:duration-300 tw:hover:brightness-90 tw:lg:px-6',
        {
          'tw:bg-brand-black tw:text-white': isActive,
          'tw:bg-transparent tw:text-brand-black': !isActive,
        }
      )}>
      {children}
    </button>
  );
};

export default SizeAndCapacityButton;
